import { c as _c } from "react/compiler-runtime";
import { logout, useJwtToken } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { Avatar } from "@website/ui/avatar";
import { Badge } from "@website/ui/badge";
import { Sheet } from "@website/ui/sheet";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { useSnappPro } from "@website/widget/header/hooks/use-snapp-pro";
import profileImage from "../../assets/avatar.svg";
import { ProfileMenuItem } from "./components/profile-menu-item";
import { useGetBalance } from "./services/get-balance-service";
interface Properties {
  isOpen: boolean;
  close: () => void;
}
export function ProfileMenu(t0) {
  const $ = _c(41);
  const {
    isOpen,
    close
  } = t0;
  const {
    name: fullName,
    phoneNumber
  } = useJwtToken();
  const {
    hasSnappPro,
    snappProIcon,
    snappProTitle,
    snappProSubTitle
  } = useSnappPro();
  const {
    balance: t1,
    isLoadingGetBalance
  } = useGetBalance();
  const {
    balance
  } = t1;
  const onClickHandler = _temp;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function onLogout() {
      logout();
      window.location.href = "/";
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onLogout = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = isChannel(["telesale"]);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTeleSalesChannel = t3;
  let t4;
  if ($[2] !== hasSnappPro || $[3] !== snappProIcon || $[4] !== snappProSubTitle || $[5] !== snappProTitle) {
    t4 = hasSnappPro ? [{
      label: snappProTitle,
      subTitle: snappProSubTitle,
      value: <Badge content={"\u0641\u0639\u0627\u0644"} color="success" />,
      icon: <img src={snappProIcon} alt="snapp-pro" />
    }] : [];
    $[2] = hasSnappPro;
    $[3] = snappProIcon;
    $[4] = snappProSubTitle;
    $[5] = snappProTitle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== balance || $[8] !== isLoadingGetBalance) {
    t5 = isTeleSalesChannel ? [] : [{
      label: "\u06A9\u06CC\u0641 \u067E\u0648\u0644",
      value: isLoadingGetBalance ? <Skeleton width={100} height={20} /> : `${numberConvert(((balance || 0) / 10).toLocaleString(), {
        locale: "fa"
      })} تومان`,
      icon: <MaterialIcon name="account_balance_wallet" variant="outlined" />,
      onClick: () => onClickHandler("/profile/wallet")
    }];
    $[7] = balance;
    $[8] = isLoadingGetBalance;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "\u0633\u0641\u0631\u0647\u0627\u06CC \u0645\u0646",
      icon: <MaterialIcon name="luggage" variant="outlined" />,
      onClick: () => onClickHandler("/profile/my-trips")
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      label: "\u0644\u06CC\u0633\u062A \u0645\u0633\u0627\u0641\u0631\u0627\u0646",
      icon: <MaterialIcon name="people" variant="outlined" />,
      onClick: () => onClickHandler("/profile/passengers-list")
    };
    t8 = isTeleSalesChannel ? [] : [{
      label: "\u0644\u06CC\u0633\u062A \u062A\u0631\u0627\u06A9\u0646\u0634 \u0647\u0627",
      value: "",
      icon: <MaterialIcon name="history" variant="outlined" />,
      onClick: () => onClickHandler("/profile/transactions")
    }];
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      label: "\u062E\u0631\u0648\u062C",
      icon: <MaterialIcon name="logout" />,
      onClick: onLogout
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t5) {
    t10 = [...t4, ...t5, t6, t7, ...t8, t9];
    $[14] = t4;
    $[15] = t5;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const profileList = t10;
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Avatar src={profileImage.src} className="size-12 max-h-12 min-w-12" size="large" type="image" variant="circular" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = fullName || "\u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631";
  let t13;
  if ($[18] !== t12) {
    t13 = <div className="text-subtitle-2 text-on-surface-high-emphasis">{t12}</div>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== phoneNumber) {
    t14 = numberConvert(phoneNumber?.replaceAll?.("+98", "0"), {
      locale: "fa"
    });
    $[20] = phoneNumber;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14) {
    t15 = <p className="text-extra-caption text-on-surface-high-emphasis">{t14}</p>;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t13 || $[25] !== t15) {
    t16 = <div>{t13}{t15}</div>;
    $[24] = t13;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== close) {
    t17 = <MaterialIcon name="chevron_left" onClick={close} className="mr-auto" />;
    $[27] = close;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <a href="/profile/information" className="flex items-center gap-4 px-6 py-2">{t11}{t16}{t17}</a>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== profileList) {
    t19 = profileList.map(_temp2);
    $[32] = profileList;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = <div className="min-w-[312px] py-3">{t18}{t19}</div>;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== close || $[38] !== isOpen || $[39] !== t20) {
    t21 = <Sheet onClose={close} open={isOpen} xGap="16px" xPosition="end" yPosition="end">{t20}</Sheet>;
    $[37] = close;
    $[38] = isOpen;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
}
function _temp2(item) {
  return <ProfileMenuItem key={item.label} {...item} />;
}
function _temp(pathname) {
  if (typeof window !== "undefined") {
    window.location.href = pathname;
  }
}